import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFullscreen2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFullscreen2"><Path d="M2 4V20H22V4H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFullscreen2;
